import React, { Component } from 'react';
import ConfiguratorSection from './../ConfiguratorSection';
import ConfiguratorImage from './../ConfiguratorImage';
import ConfiguratorOption from './../ConfiguratorOption';
import MaterialSelector from '../MaterialSelector';
import TransomConfigurator from './../TransomConfigurator';
import { withTranslation, Trans } from 'react-i18next';
import { exterior_view01ImageOptions } from './views/exterior_view01'

class XC45Sprayhood extends Component {
    constructor(props) {
        super(props);
        this.handleSprayhoodChange = this.handleSprayhoodChange.bind(this);
        this.handleBoomCoverChange = this.handleBoomCoverChange.bind(this);
    }


    handleSprayhoodChange(newValue) {
        let configuration = this.props.configuration;
        configuration.Sprayhood = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    handleBoomCoverChange(newValue) {
        let configuration = this.props.configuration;
        configuration.BoomCover = newValue;

        if (this.props.onChange) {
            this.props.onChange(configuration);
        }
    }

    render() {
        let imageOptions = exterior_view01ImageOptions;

        let image = (
            <TransomConfigurator colorMultiplier={0.75} name={this.props.transom.Name} port={this.props.transom.Port} transomSize={{ width: 1800, height: 785 }} transform={
                [
                    0.057062, -0.021958, 0, -0.000083,
                    0.019683, 0.118142, 0, 0.000024,
                    0, 0, 1, 0,
                    275, 373, 0, 1
                ]}>
                <ConfiguratorImage boat="XC45" configuration={this.props.configuration} options={imageOptions} />
            </TransomConfigurator>
        );

        return (
            <ConfiguratorSection image={image}>
                
                <ConfiguratorOption>

                    <h1><Trans defaults='Sprayhood & Boom Cover' /></h1>

                    <p><Trans defaults='Excellent cockpit protection with various options.' /></p>
                    <p><Trans defaults='In this configurator, you can visualize the sprayhood and boom cover options only.' /></p>
                    <p><Trans defaults='Apart from the options below, sprayhood and boom cover - there are also options for cockpit tent, bimini, cockpit cushions and forestay cover. These options are not included in the configurator. Please, contact your local dealer for more information.' /></p>

                    <h2><Trans defaults='Sprayhood' /></h2>
                    <MaterialSelector label={this.props.configuration.Sprayhood.label} options={this.props.sprayhoodOptions} value={this.props.configuration.Sprayhood} onChange={this.handleSprayhoodChange} />
                    
                    <h2><Trans defaults='Boom Cover' /></h2>
                    <MaterialSelector label={this.props.configuration.BoomCover.label} options={this.props.boomCoverOptions} value={this.props.configuration.BoomCover} onChange={this.handleBoomCoverChange} />
                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(XC45Sprayhood);


// WEBPACK FOOTER //
// ./src/XC45/XC45Sprayhood.js